import {SPLASH_SCREEN_RESPONSE} from "modules/Common/reducers/splashpage";
import {LOGIN} from "../reducers/skysso";
import {WINDOW_LOAD} from "../actions/windowEvents";
import {middlewareWrapper} from "../../../utils/middlewareUtils";

const getPath = uri => (user = {}, trigger) => {
  const queryFields =  {
    fullyregistered: "userFullyRegistered",
    canbet: "canBet"
  };

  return Object.keys(user).reduce((queryString, key) => {
    if (!queryFields[key] || typeof user[key] === "undefined") {
      return queryString
    }
    return `${queryString}&${queryFields[key]}=${user[key]}`

  }, `${uri}?trigger=${trigger}`);
};

function createSplashPageAction(trigger, campaignGroup) {
  const data = {
    ...campaignGroup.splashPage,
    endDateTime: campaignGroup.endDateTime
  };

  return {
    type: SPLASH_SCREEN_RESPONSE,
    trigger,
    data
  };
}

export default (apiClient, config) => {

  const { cmsCampaignGroupsUri } = config.api.campaignGroups;
  const getCampaignGroupPath = getPath(cmsCampaignGroupsUri);

  function getLoginSplashpage(store, next, action) {
    if (action.type === LOGIN) {
      const { user } = action.data;
      const path = getCampaignGroupPath(user, "Login");

      apiClient.get(path)
        .then(campaignGroups => {
          if(campaignGroups[0]) {
            store.dispatch(createSplashPageAction('login', campaignGroups[0]));
          }
        })
        .catch(() => {});
    }

    next(action)
  }

  function getWindowLoadSplashpage(store, next, action) {
    if (action.type === WINDOW_LOAD) {
      const { user } = store.getState().common.auth;
      const path = getCampaignGroupPath(user, "Site Load");

      apiClient.get(path)
        .then(campaignGroups => {
          if(campaignGroups[0]) {
            store.dispatch(createSplashPageAction('siteLoad', campaignGroups[0]))
          }
        })
        .catch(() => {});
    }
    next(action)
  }

  return [
    middlewareWrapper(getLoginSplashpage),
    middlewareWrapper(getWindowLoadSplashpage),
  ]
}



// WEBPACK FOOTER //
// ./modules/Common/middleware/splashpageMiddleware.js